<template>
  <main-layout :selectedMenu="'2'">
    <!-- <div class="top container">
      <div class="top-filter">
        <div class="top-tabs">
          <div class="top-tab" v-on:click="GotoUrl('/explorevideo')">{{$t('global.视频')}}</div>
          <div class="top-tab active">{{$t('global.创作者')}}</div>
          <div class="top-tab" v-on:click="GotoUrl('/exploresubject')">{{$t('global.频道')}}</div>
        </div>
        <div class="top-tab-contents">
          <div class="top-tab-content">
            <filter-table
              v-model="selectedFilters"
              v-on:select-changed="FilterChanged"
              v-bind:cate="filterList"
              :singleselect="true"
              :showall="true"
            ></filter-table>
          </div>
        </div>
      </div>
      <div class="filter-result">
        <span class="pre">{{$t('global.已选条件')}}</span>
        <el-button-group v-for="(item,index) in selectedFilters" :key="index">
          <el-button plain round size="mini">{{item.name}}</el-button>
          <el-button plain icon="el-icon-close" round size="mini" @click="deleteFilter(index)"></el-button>
        </el-button-group>
      </div>
    </div> -->
    <div class="middle container">
      <AuthorList :itemList="videoList" :small="true"></AuthorList>
      <pages
        :page-size="pagerParam.pageSize"
        :page-count="pagerParam.pageCount"
        :current-page="pagerParam.currentPage"
        :total="pagerParam.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import item from "../../components/item.vue";
import pages from "../../components/pages.vue";
import FilterTable from "../../components/FilterTable.vue";
import AuthorList from "../../components/author/AuthorList";

export default {
  name: "ExploreVedio",
  metaInfo() {
    return {
      title: this.$t("global.发现创作者") + " | MANA"
    };
  },
  components: {
    MainLayout,
    item,
    pages,
    FilterTable,
    AuthorList
  },
  data() {
    return {
      selectedFilters: [],
      filterList: [],
      isCertification: "",
      initial: "",
      city: "",
      videoList: [],
      pagerParam: {
        pageSize: 10,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  created() {
    var $this = this;
    $this.filterList = [
      {
        name: this.$t("global.认 证"),
        list: [
          { name: this.$t("global.认证"), value: 1, cat: 1 },
          { name: this.$t("global.非认证"), value: 2, cat: 1 }
        ]
      },
      {
        name: this.$t("global.国 家"),
        list: []
      }
    ];
    var alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    for (var i = 0; i < alpha.length; i++) {
      $this.filterList[1].list.push({
        name: alpha[i],
        value: alpha[i],
        cat: 2
      });
    }
    this.GetVideoList();
    this.buriedPoint(38,0)
  },
  methods: {
    GoToSubjectDetail() {
      this.$router.push("/subjectdetail");
    },
    GetVideoList() {
      const url = `/api/mobile/author/indexPageList`;
      const params = {
        isCertification: this.isCertification,
        initial: this.initial,
        pageIndex: this.pagerParam.currentPage,
        pageSize: this.pagerParam.pageSize
      };
      this.$http.get(url, { params }).then(response => {
        if (response.code === "OK") {
          this.videoList = response.data.list;
          this.videoList.map(function(item) {
            item.items = item.videoResponseList;
          });
          this.pagerParam.pageCount = response.data.totalPage;
          this.pagerParam.currentPage = response.data.pageIndex;
          this.pagerParam.total =
            response.data.totalRecord > 1000 ? 1000 : response.data.totalRecord;
        }
      });
    },
    FilterChanged() {
      this.isCertification = "";
      this.initial = "";
      this.city = "";
      this.pagerParam.currentPage = 1;
      for (var i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].cat == 1) {
          this.isCertification = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 2) {
          this.initial = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 3) {
          this.city = this.selectedFilters[i].value;
        }
      }
      this.$forceUpdate();
      this.GetVideoList();
    },
    GotoUrl(url) {
      this.$router.push(url);
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetVideoList();
    },
    deleteFilter(index) {
      this.selectedFilters.splice(index, 1);
      this.FilterChanged();
    }
  }
};
</script>

<style scoped>
.top {
  padding-top: 0.6rem;
}
.top-filter {
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  overflow: hidden;
  zoom: 1;
}
.top-tabs {
  width: 140px;
  float: left;
  font-size: 0.26rem;
}
.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}
.top-tab.active {
  background-color: #fff;
  color: #333333;
}
.top-tab-contents {
  width: 1020px;
  float: left;
}
.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}
.filter-result .pre {
  margin-right: 0.4rem;
}
.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}
.filter-result .el-button-group {
  margin-right: 0.2rem;
}
.orderby {
  margin-top: 0.4rem;
  margin-bottom: 0.17rem;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}
.orderby .active {
  color: #333;
}
.orderby label {
  cursor: pointer;
}
.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.14rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.14rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.vedio-list .el-row {
  margin: 0 -0.13rem;
}
.vedio-list .item {
  margin: 0.13rem;
  cursor: pointer;
}

.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url("/static/explore/user.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.14rem;
  background: url("/static/explore/vediocount.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/explore/ExploreAuth.vue